
import React, { useEffect, useState } from 'react'
import { Card, Dialog, DialogContent, IconButton, TextField, Typography } from '@material-ui/core'
import CancelOutlined from '@material-ui/icons/CancelOutlined'
import { deleteGDCDetaliedPlanHistory, getGDCDetaliedPlanHistory } from '@auteco/services/gdcServices'
import { useStyles } from './styles'

const ListHistoryNotes = ({ open, onClose, id, isEnabled }) => {
    const [notes, setNotes] = useState([])
    const [filteredNotes, setFilteredNotes] = useState([])
    const [date, setDate] = useState('')

    const classes = useStyles()

    const dateToLocal = (dateStr) => {
        const dateUTCObj = new Date(dateStr);
        const dateLocal = new Date(dateUTCObj.getTime() - (5 * 60 * 60 * 1000))
        const year = dateLocal.getFullYear();
        const month = String(dateLocal.getMonth() + 1).padStart(2, '0');
        const day = String(dateLocal.getDate()).padStart(2, '0');
        const hours = String(dateLocal.getHours()).padStart(2, '0');
        const minutes = String(dateLocal.getMinutes()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        const formattedDateAndHour = `${year}-${month}-${day} ${hours}:${minutes}`;
        return {
            formattedDateAndHour,
            formattedDate
        }
    }

    const getNotes = async () => {
        const { historico } = await getGDCDetaliedPlanHistory({ id })
        if (historico) {
            setNotes(historico)
            if (date !== '') {
                const newNotes = historico.filter(note => dateToLocal(note.creacion).formattedDate === date)
                setFilteredNotes(newNotes)
            } else {
                setFilteredNotes(historico)
            }
        }
    }

    const filterNotes = (value) => {
        setDate(value)
        const newNotes = notes.filter(note => dateToLocal(note.creacion).formattedDate === value)
        setFilteredNotes(newNotes)
    }

    const deleteNote = async (noteID) => {
        const { success } = await deleteGDCDetaliedPlanHistory({ id: noteID })
        if (success) {
            getNotes()
        }
    }

    const handleClose = () => {
        onClose()
        setDate('')
        setNotes([])
    }

    useEffect(() => {
        if (open) {
            getNotes()
        }
    }, [open]);
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogContent className={classes.container}>
                <div className={classes.filterContainer}>
                    <Typography className={classes.filterTitle}>Filtrar por fecha</Typography>
                    <TextField
                        type='date'
                        variant='outlined'
                        className={classes.textField}
                        onChange={(e) => filterNotes(e.target.value)}
                    />
                </div>
                <Typography className={classes.title}>Histórico</Typography>
                {filteredNotes.length > 0 &&
                    <div>
                        {filteredNotes?.map(item => (
                            <Card className={classes.card}>
                                <IconButton
                                    className={classes.iconBtn}
                                    disabled={!isEnabled}
                                    onClick={() => deleteNote(item.id)}
                                >
                                    <CancelOutlined />
                                </IconButton>
                                <Typography>{item.texto}</Typography>
                                <Typography>Creación: {dateToLocal(item.creacion).formattedDateAndHour}</Typography>
                            </Card>
                        ))}
                    </div>
                }
                {filteredNotes.length === 0 &&
                    <Typography>No hay histórico disponible</Typography>
                }
            </DialogContent>
        </Dialog>
    )
}

export { ListHistoryNotes }